import React from 'react';
import { ScrollReveal } from '../components/ScrollReveal';
import { CountdownTimer } from '../components/CountdownTimer';
export function UrgencySection() {
  return <section className="bg-gradient-to-b from-cosmic-urgency to-cosmic-black relative z-10 py-12 px-6" data-id="element-318">
      <ScrollReveal className="max-w-3xl mx-auto flex flex-col items-center text-center" data-id="element-319">
        <h2 className="font-lato text-lunar-white text-3xl md:text-4xl font-bold leading-tight mb-4" data-id="element-320">
          This Price Disappears at Midnight.
        </h2>

        <CountdownTimer data-id="element-321" />

        <div className="text-lunar-lavender text-lg leading-relaxed font-lato space-y-6 max-w-2xl mt-4" data-id="element-322">
          <p data-id="element-323">
            The Midnight Magnet is currently available at the introductory price
            of <span className="text-gold font-bold" data-id="element-324">$6.37</span>.
          </p>
          <p data-id="element-325">
            This price was set intentionally — to make sure no woman is left
            behind because of money.
          </p>
          <p data-id="element-326">
            But this window is closing. When the timer hits zero, the price
            increases to $27.
          </p>
          <p className="text-cta-red font-bold text-xl pt-4" data-id="element-327">
            Don't let this be one more thing you almost did for yourself.
          </p>
        </div>
      </ScrollReveal>
    </section>;
}